import { render, staticRenderFns } from "./IAvatar.vue?vue&type=template&id=39485ef3&scoped=true&"
import script from "./IAvatar.vue?vue&type=script&lang=js&"
export * from "./IAvatar.vue?vue&type=script&lang=js&"
import style0 from "./IAvatar.vue?vue&type=style&index=0&id=39485ef3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39485ef3",
  null
  
)

export default component.exports